export class AuthorisationCreateViewEditCancel
{
    createAllow:string;
    editAllow:string;
    viewAllow:string;
    cancelAllow:string;
}